<template>
    <div class="unsubscribeCon" :class=" { active: isShow}">
        <div class="unsubscribeCon-bg" @click="onCloseNrpPopup"></div>
        <div class="unsubscribeContainer">
            <div class="unsubscribeCon-bubbleInfo js-smartScroll scroll-container" v-html="nrpDescription">
                
            </div>
            <div class="close" @click="onCloseNrpPopup"><i class="f7-icons">close_round_fill</i></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NrpPopup",
    props: {
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        nrpTitle: {
            type: String
        },
        nrpDescription: {
            type: String
        },
        onCloseNrpPopup: {
            type: Function
        }
    }
}
</script>

<style lang="less" scoped>
.unsubscribeCon {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5111;
    display: none;
    .unsubscribeCon-bg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.4);
    }
    .unsubscribeContainer {
        width: 340px;
        margin: 0 auto;
        margin-top: 100px;
        background-color: #fff;
        padding: 10px;
        position: relative;
        .unsubscribeCon-bubbleInfo {
            max-height: 320px;
            overflow-y: auto;
            .cabinDetail-box {
                padding: 0 10px;
                background-color: #fff;
            }
            .cabinDetail-txt {
                padding-bottom: 13px;
                font-size: 12px;
                line-height: 20px;
                color: #666;
            }
        }
        .close {
            position: absolute;
            top: 0;
            right: 0;
            .f7-icons {
                font-size: 21px;
                color: #2c3466;
                padding: 3px;
            }
        }
    }
}

.unsubscribeCon.active {
    display: block;
}
</style>

<style>
.unsubscribeCon-bubbleInfo p {
    font-size: 12px;
    color: #5e5e5e;
    margin-bottom: 0;
    margin-top: 4px;
}
.cabinDetail-txt .cabinDetail-txt-bold {
    margin: 10px 0 0;
}
.unsubscribeCon-bubbleInfo p span {
    font-size: 13px;
    color: #4A90E2;
    font-weight: 600;
}
</style>